import AuthViewLayout from "./AuthViewLayout";

export default AuthViewLayout;
